import React from "react";
import { Box, Container, Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { NavigateNext } from "@mui/icons-material";
import { ItemIssueForm } from "../../components/ItemIssue/ItemIssueForm";

export const InvCreateItemIssuePage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ mb: 2 }}
        >
          <Link
            component={RouterLink}
            to="/dashboard"
            underline="hover"
            color="inherit"
          >
            Dashboard
          </Link>
          <Link
            component={RouterLink}
            to="/item-issues"
            underline="hover"
            color="inherit"
          >
            Item Issues
          </Link>
          <Typography color="text.primary">New Item Issue</Typography>
        </Breadcrumbs>
      </Box>

      <ItemIssueForm />
    </Container>
  );
};
